import { createContext } from 'react';

function recursivelyAddTooltipAttrsToChildNodes(domNode, tooltipId, isTrigger) {
  if (domNode) {
    domNode.setAttribute("data-tooltip-id", tooltipId);
    if (isTrigger) domNode.setAttribute("data-tooltip-target", "true");
    for (var _i = 0, _Array$from = Array.from(domNode.children); _i < _Array$from.length; _i++) {
      var child = _Array$from[_i];
      if (child.nodeType !== Node.TEXT_NODE) {
        child.setAttribute("data-tooltip-id", tooltipId);
        if (isTrigger) child.setAttribute("data-tooltip-target", "true");
        if (child.children) {
          recursivelyAddTooltipAttrsToChildNodes(child, tooltipId);
        }
      }
    }
  }
}
var TooltipComponentContext = /*#__PURE__*/createContext({
  triggerDomRecrawl: function triggerDomRecrawl() {}
});

export { TooltipComponentContext as T, recursivelyAddTooltipAttrsToChildNodes as r };
//# sourceMappingURL=shared2.js.map
